import React from "react";
import "./Change_Passoword_Modal.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Change_Passoword_Modal({ ...props }) {

    const navigate = useNavigate()

  return (
    <Modal
      {...props}
      centered
      size="sm"
      backdrop="static"
      className="Commission_Receive_modal Change_Passoword_Modal  Common_modal"
    >
      <Modal.Body>
        <div className="Commission_Receive">
          <div className="content_holder">
            <p>Cannot received verification code?</p>
          </div>

          <div className="upi_button_wrapper d-flex gap-2">
            <button className="blue_btn" onClick={() => navigate("/self-service-change-password")}>
              Can Receive
            </button>
            <button className="blue_btn" onClick={() => navigate("/change-login-password")}>
              Cannot Receive
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Change_Passoword_Modal;
